// extracted by mini-css-extract-plugin
export var editButton = "_kp-0";